<template>
  <div class="input-panel panel-term">
      <h2 class="input-panel__head">Term Length(s)</h2>
      <div class="panel-term__row panel-term__row--center mrgn-btm-10">
        <span class="sz-n">Ending within 60 months from today</span>
      </div>
      <multiple-term></multiple-term>
  </div>
</template>

<script>
import Multi from './MultiTerm.vue'

export default {
  components: {
    'multiple-term': Multi,
  }
}
</script>
